import { render, staticRenderFns } from "./TranslationPreview.vue?vue&type=template&id=c3c4db52&"
import script from "./TranslationPreview.vue?vue&type=script&lang=js&"
export * from "./TranslationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports